<template lang="html">
  <div v-if="student" class="row">
    <div class="col-12">
      <article class="fc-m-container">
        <h2>Edit Student</h2>
        <div class="row">
          <div class="col-12 col-md-6">
            <form @submit="updateStudent">
              <div class="form-group">
                <label for="username">Username</label>
                <input
                  v-model="username"
                  class="form-control"
                  type="text"
                  name="username"
                  value=""
                />
              </div>
              <button type="submit" class="btn btn-primary">Update</button>
            </form>
          </div>
        </div>
      </article>
    </div>
    <div class="col-12">
      <article class="fc-m-container">
        <h2>Change password</h2>
        <div class="row">
          <div class="col-12 col-md-6">
            <form @submit="changePassword">
              <div class="form-group">
                <label for="password1">New Password</label>
                <input
                  v-model="newPassword1"
                  class="form-control"
                  type="password"
                  name="new_password1"
                  value=""
                />
              </div>
              <div class="form-group">
                <label for="password2">Confirm New Password</label>
                <input
                  v-model="newPassword2"
                  class="form-control"
                  type="password"
                  name="new_password2"
                  value=""
                />
              </div>
              <button type="submit" class="btn btn-primary">Submit</button>
            </form>
          </div>
        </div>
      </article>
    </div>
    <div class="col-12">
      <article class="fc-m-container">
        <h2>Leagues</h2>
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Team</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="league in student.leagues"
              :key="league.id"
              :set="(team = checkForTeam(league.teams, student.id))"
            >
              <td>
                <router-link :to="`/leagues/${league.id}`">{{
                  league.name
                }}</router-link>
              </td>
              <td>
                <router-link
                  v-if="team"
                  :to="`/leagues/${league.id}/teams/${team.id}`"
                  >{{ team.name }}</router-link
                >
              </td>
            </tr>
            <tr v-if="student.leagues.length == 0">
              <td colspan="2">No leagues to display.</td>
            </tr>
          </tbody>
        </table>
      </article>
    </div>
  </div>
  <loader v-else v-bind:embeded="false"></loader>
</template>

<script>
import { getCookie } from "@/utils/cookies.js";
import Loader from "@/views/components/Loader";
import { handleErrors, handleFormErrors } from "@/utils/errors.js";

export default {
  name: "StudentsEdit",
  data: function() {
    return {
      student: null,
      username: "",
      newPassword1: "",
      newPassword2: ""
    };
  },
  components: {
    loader: Loader
  },
  created: function() {
    if (this.$store.state.auth.account_type != "educator") {
      this.$router.push("/leagues");
      this.$store.commit("alert/addMessage", {
        message: `You do not have access to view that page.`,
        class: "warning",
        persist: false
      });
    } else {
      this.getStudent();
    }
  },
  methods: {
    checkForTeam: function(teams, studentId) {
      let team = teams.find(function(team) {
        return team.owners.find(owner => owner.id == studentId) ? true : false;
      });
      return team;
    },
    getStudent: function() {
      let app = this;
      let status;
      app.student = null;
      let url = `${process.env.VUE_APP_PLATFORM}/accounts/${
        this.$store.state.auth.user_id
      }/students/${this.$route.params.studentId}`;

      fetch(url, {
        credentials: "include",
        mode: "cors"
      })
        .then(function(response) {
          status = response.status;
          return response.json();
        })
        .then(function(response) {
          if (status == 200) {
            app.username = response.username;
            app.$store.commit("breadcrumb/setCurrentPage", {
              name: response.username
            });
            app.$store.commit("breadcrumb/display");
            app.student = response;
          } else {
            app.$store.commit("alert/addMessage", {
              message: `Unable to get student.`,
              class: "danger",
              persist: false
            });
          }
        });
    },
    updateStudent: function(e) {
      e.preventDefault();

      let app = this;
      let status;
      const csrftoken = getCookie("csrftoken");
      let form = new URLSearchParams({
        username: app.username
      });
      let url = `${process.env.VUE_APP_PLATFORM}/accounts/${
        this.$store.state.auth.user_id
      }/students/${this.$route.params.studentId}/`;

      fetch(url, {
        credentials: "include",
        method: "PATCH",
        mode: "cors",
        body: form,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRFToken": csrftoken
        }
      })
        .then(function(response) {
          status = response.status;
          return response.json();
        })
        .then(function(response) {
          if (status == 200) {
            app.getStudent();
            app.$store.commit("alert/addMessage", {
              message: `Username updated!`,
              class: "success",
              persist: false
            });
          } else {
            handleErrors(response);
          }
        });
    },
    changePassword: function(e) {
      e.preventDefault();

      let app = this;
      const csrftoken = getCookie("csrftoken");

      let form = new URLSearchParams({
        new_password1: app.newPassword1,
        new_password2: app.newPassword2
      });

      let url = `${process.env.VUE_APP_PLATFORM}/accounts/${
        this.$store.state.auth.user_id
      }/students/${this.$route.params.studentId}/change-password/`;

      fetch(url, {
        credentials: "include",
        method: "POST",
        mode: "cors",
        body: form,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRFToken": csrftoken
        }
      }).then(function(response) {
        if (response.status == 200) {
          app.newPassword1 = "";
          app.newPassword2 = "";
          app.$store.commit("alert/addMessage", {
            message: `Student password has been updated!`,
            class: "success",
            persist: false
          });
        } else {
          response.json().then(function(response) {
            handleFormErrors(response.errors);
          });
        }
      });
    }
  }
};
</script>
